<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <div
          class="d-flex justify-content-between align-items-md-center align-items-start flex-md-row flex-column mb-2"
        >
          <piaf-breadcrumb :heading="$t('menu.list')" />

          <router-link to="/admin/payment-terms/create" class="btn btn-primary top-right-button">
            {{ $t('buttons.addNew') }}
          </router-link>
        </div>

        <div class="separator mb-5" />
      </b-colxx>
    </b-row>

    <template v-if="isLoading">
      <div class="loading"></div>
    </template>

    <template v-else>
      <data-list-item :paymentTerms="paymentTerms" @update="fetchPaymentTerms" />
    </template>
  </div>
</template>

<script>
import DataListItem from '@/components/Pages/PaymentTerms/DataList.vue'
import { handleArrayDataInternalization } from '@/utils'

export default {
  components: {
    'data-list-item': DataListItem
  },
  computed: {
    paymentTerms() {
      const paymentTerms = this.$store.getters['paymentTerms/paymentTerms']
      return handleArrayDataInternalization(paymentTerms, ['name'], this.$i18n.locale)
    },
    isLoading() {
      return this.$store.getters['paymentTerms/isLoading']
    }
  },
  mounted() {
    this.fetchPaymentTerms()
  },
  methods: {
    fetchPaymentTerms() {
      this.$store.dispatch('paymentTerms/fetchPaymentTerms')
    }
  }
}
</script>
